import { render, staticRenderFns } from "./channelShopList.vue?vue&type=template&id=362142ba&scoped=true&"
import script from "./channelShopList.vue?vue&type=script&lang=js&"
export * from "./channelShopList.vue?vue&type=script&lang=js&"
import style0 from "./channelShopList.vue?vue&type=style&index=0&id=362142ba&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362142ba",
  null
  
)

export default component.exports